var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('img',{staticClass:"background",attrs:{"src":require("../assets/imgs/home.jpg"),"alt":""}}),_c('img',{staticClass:"button",attrs:{"src":require("../assets/imgs/buttonplay.png"),"alt":"点击前往查看"},on:{"click":function($event){return _vm.$router.push('/folkCulture')}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }